import React from 'react';
import NoFound from 'components/NoFound/NoFound';

const NotFound = () => {
  return <NoFound />;
};

export default NotFound;
